var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media_report_warp"},[_c('NewsCard',{attrs:{"type":_vm.NEWS_CENTER_TYPE.mediaReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }